import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';

interface ILogin {
    variables?: {
        username?: string;
        password?: string;
    };
}

export const LOGIN = gql`
    mutation UseLogin($username: String!, $password: String!) {
        login(input: { username: $username, password: $password }) {
            access_token
            expires_in
            user {
                name
                email
                id
            }
        }
    }
`;
const useLogin = ({ variables }: ILogin) => {
    return useMutation(LOGIN, {
        variables,
        awaitRefetchQueries: true,
        refetchQueries: ['GetNodes'],
    });
};

export { useLogin };
